export const HOME = { landingLink: "home-landing-link" };

export const NOTCH = {
  // Brand
  appBrand: "notch-brand",
  // Auth
  authEmail: "auth-email-input",
  authPassword: "auth-password-input",
  authName: "auth-name-input",
  authSubmit: "auth-submit-btn",
  authToggle: "auth-toggle-mode",
  authError: "auth-error",
  // Header / nav
  navLogout: "nav-logout-btn",
  navDashboard: "nav-dashboard-link",
  navPricing: "nav-pricing-link",
  navPhotoLog: "nav-photolog-link",
  // Profile
  ageInput: "profile-age-input",
  genderSelect: "profile-gender-select",
  heightInput: "profile-height-input",
  weightInput: "profile-weight-input",
  activitySelect: "profile-activity-select",
  // Targets preview
  targetsCard: "targets-preview-card",
  targetWeight: "target-weight-value",
  targetKcal: "target-kcal-value",
  targetProtein: "target-protein-value",
  targetBmi: "target-bmi-value",
  // Restrictions
  pill: (slug) => `restriction-pill-${slug}`,
  customDietInput: "custom-diet-input",
  customDietCounter: "custom-diet-counter",
  goalSelect: "goal-select",
  cuisineSelect: "cuisine-select",
  mealsCountSelect: "meals-count-select",
  daysSelect: "days-select",
  // Actions
  generateBtn: "generate-suggestions-btn",
  resetBtn: "reset-form-btn",
  factsLoader: "health-facts-loader",
  // Results
  resultsSection: "results-section",
  dayTab: (i) => `day-tab-${i}`,
  mealCard: (i) => `meal-card-${i}`,
  resultsNote: "results-note",
  shareBtn: "share-plan-btn",
  shareLink: "share-link-value",
  groceryListSection: "grocery-list-section",
  // About
  aboutCard: "about-app-card",
  errorBanner: "error-banner",
  // Pricing / billing
  upgradeBtn: "upgrade-pro-btn",
  freeBadge: "free-quota-badge",
  proBadge: "pro-badge",
  // Photo log
  photoInput: "photo-upload-input",
  photoSubmit: "photo-submit-btn",
  photoEditCalories: "photo-edit-calories",
  photoEditProtein: "photo-edit-protein",
  photoEditCarbs: "photo-edit-carbs",
  photoEditFat: "photo-edit-fat",
  photoSaveEdits: "photo-save-edits-btn",
  photoLogItem: (i) => `photolog-item-${i}`,
};
